import React, { Component, PropTypes } from 'react';
import {english, swedish} from "./renderTaC";
import AppPage from '../AppPage';
import RulerBar from '../RulerBar';
import FullWidthPane from '../FullWidthPane';
import {AuthStore} from "../../stores";
import { mixin, RefluxMixin } from '../../Util';

const css = oxygenCss({
  content: {
    width: 960,
    maxWidth: '100%',
    boxSizing: 'border-box',
    padding: 64,
    margin: 'auto'
  }
});

export default class TaC extends mixin(RefluxMixin, Component) {
  static contextTypes = {
    getIntlMessage: PropTypes.func
  };

  listenToStores() {
    this.listenToStoreWithMapper(
      AuthStore,
      state => ({
        locale: state.locale
      }),
      {
        locale: 'en_US'
      }
    );
  }

  render() {
    const { locale } = this.state;
    return (
      <AppPage key="TaC" header={
          <RulerBar title={this.context.getIntlMessage('menu.TaC')} />
        }
      >
        <FullWidthPane>
          <div className={css.content}>
            {locale === 'sv_SE' ? swedish : english}
          </div>
        </FullWidthPane>
      </AppPage>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/TaC/TaC.js